var _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 72,
    viewBox: "0 0 179 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 66",
    filter: "url(#filter0_d_751_5008)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 4,
    width: 154,
    height: 48,
    rx: 12,
    fill: "url(#paint0_linear_751_5008)",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4.5,
    width: 153,
    height: 47,
    rx: 11.5,
    stroke: "#3F237C",
    style: {
      stroke: "#3F237C",
      stroke: "color(display-p3 0.2458 0.1358 0.4865)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0232 14.2828C23.6918 14.6211 23.5 15.1477 23.5 15.8297V40.1562C23.5 40.8382 23.6918 41.3648 24.0232 41.7031L24.105 41.7773L38.0863 28.1511V27.8293L24.105 14.2031L24.0232 14.2828Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.4346 32.6948L39.7793 28.1505V27.8287L44.4402 23.2843L44.5446 23.3435L50.0643 26.4056C51.6396 27.2746 51.6396 28.7046 50.0643 29.5791L44.5446 32.6357L44.4346 32.6948Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.6975 33.4822L38.9322 28.836L24.8691 42.5489C25.3923 43.0852 26.2456 43.1498 27.2158 42.6135L43.6975 33.4822Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.6975 22.4979L27.2158 13.3665C26.2456 12.8358 25.3923 12.9004 24.8691 13.4367L38.9322 27.144L43.6975 22.4979Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M66.5926 17.2581C66.5926 18.1766 66.3105 18.9123 65.7549 19.4609C65.116 20.1113 64.284 20.4385 63.2644 20.4385C62.2899 20.4385 61.4578 20.1058 60.7753 19.4499C60.0913 18.7844 59.75 17.9676 59.75 16.99C59.75 16.0124 60.0913 15.1956 60.7753 14.5356C61.4578 13.8743 62.2899 13.5415 63.2644 13.5415C63.7495 13.5415 64.212 13.6391 64.6535 13.8206C65.0935 14.0035 65.4517 14.251 65.7112 14.5563L65.1217 15.1365C64.669 14.6154 64.0527 14.3583 63.2644 14.3583C62.5536 14.3583 61.9373 14.6003 61.4141 15.0884C60.8965 15.5779 60.637 16.2118 60.637 16.99C60.637 17.7683 60.8965 18.4076 61.4141 18.8971C61.9373 19.3798 62.5536 19.6273 63.2644 19.6273C64.0188 19.6273 64.6535 19.3798 65.1541 18.8916C65.4841 18.5685 65.6717 18.123 65.721 17.5538H63.2644V16.759H66.5418C66.5813 16.9309 66.5926 17.0973 66.5926 17.2581Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.135385,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M71.7929 14.5027H68.7143V16.5927H71.4897V17.3875H68.7143V19.4775H71.7929V20.2874H67.8428V13.6929H71.7929V14.5027Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.135385,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M75.463 20.2874H74.5915V14.5027H72.7031V13.6929H77.3527V14.5027H75.463V20.2874Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.135385,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M80.7168 20.2874V13.6929H81.5869V20.2874H80.7168Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.135385,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T_2",
    d: "M85.4444 20.2874H84.5799V14.5027H82.6846V13.6929H87.3398V14.5027H85.4444V20.2874Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.135385,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M96.1428 19.4389C95.4757 20.1058 94.6493 20.4385 93.6636 20.4385C92.6722 20.4385 91.8457 20.1058 91.1787 19.4389C90.5131 18.7734 90.1816 17.9566 90.1816 16.99C90.1816 16.0234 90.5131 15.2066 91.1787 14.5411C91.8457 13.8743 92.6722 13.5415 93.6636 13.5415C94.6437 13.5415 95.4701 13.8743 96.1372 14.5466C96.8084 15.2176 97.1399 16.0289 97.1399 16.99C97.1399 17.9566 96.8084 18.7734 96.1428 19.4389ZM91.8232 18.8861C92.3252 19.3798 92.9359 19.6273 93.6636 19.6273C94.3856 19.6273 95.0019 19.3798 95.4983 18.8861C95.999 18.3925 96.2528 17.7586 96.2528 16.99C96.2528 16.2214 95.999 15.5875 95.4983 15.0939C95.0019 14.6003 94.3856 14.3528 93.6636 14.3528C92.9359 14.3528 92.3252 14.6003 91.8232 15.0939C91.3225 15.5875 91.0687 16.2214 91.0687 16.99C91.0687 17.7586 91.3225 18.3925 91.8232 18.8861Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.135385,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M98.3623 20.2874V13.6929H99.42L102.709 18.8216H102.747L102.709 17.5539V13.6929H103.579V20.2874H102.671L99.2268 14.9056H99.1887L99.2268 16.1789V20.2874H98.3623Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.135385,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Google Play",
    d: "M89.9671 29.9176C87.3173 29.9176 85.1525 31.8839 85.1525 34.5967C85.1525 37.2876 87.3173 39.2745 89.9671 39.2745C92.6227 39.2745 94.7874 37.2876 94.7874 34.5967C94.7874 31.8839 92.6227 29.9176 89.9671 29.9176ZM89.9671 37.432C88.5132 37.432 87.2623 36.2618 87.2623 34.5967C87.2623 32.9096 88.5132 31.7601 89.9671 31.7601C91.4211 31.7601 92.6777 32.9096 92.6777 34.5967C92.6777 36.2618 91.4211 37.432 89.9671 37.432ZM79.4621 29.9176C76.8066 29.9176 74.6475 31.8839 74.6475 34.5967C74.6475 37.2876 76.8066 39.2745 79.4621 39.2745C82.1162 39.2745 84.2768 37.2876 84.2768 34.5967C84.2768 31.8839 82.1162 29.9176 79.4621 29.9176ZM79.4621 37.432C78.0068 37.432 76.7516 36.2618 76.7516 34.5967C76.7516 32.9096 78.0068 31.7601 79.4621 31.7601C80.9161 31.7601 82.167 32.9096 82.167 34.5967C82.167 36.2618 80.9161 37.432 79.4621 37.432ZM66.9616 31.3517V33.34H71.8313C71.6888 34.451 71.308 35.2677 70.7242 35.837C70.0134 36.5245 68.9064 37.2876 66.9616 37.2876C63.9648 37.2876 61.6182 34.9295 61.6182 32.0076C61.6182 29.0857 63.9648 26.7276 66.9616 26.7276C68.582 26.7276 69.761 27.345 70.6311 28.1452L72.0682 26.7441C70.8511 25.6111 69.2322 24.7407 66.9616 24.7407C62.8522 24.7407 59.3984 28.0009 59.3984 32.0076C59.3984 36.0144 62.8522 39.2745 66.9616 39.2745C69.1828 39.2745 70.8511 38.565 72.1627 37.234C73.5066 35.9236 73.9255 34.0811 73.9255 32.5934C73.9255 32.1314 73.886 31.7065 73.8155 31.3517H66.9616ZM118.078 32.8931C117.681 31.8467 116.459 29.9176 113.968 29.9176C111.5 29.9176 109.446 31.8137 109.446 34.5967C109.446 37.2175 111.479 39.2745 114.205 39.2745C116.409 39.2745 117.681 37.9641 118.205 37.201L116.569 36.1381C116.023 36.9164 115.28 37.432 114.205 37.432C113.138 37.432 112.372 36.9548 111.881 36.0143L118.299 33.4252L118.078 32.8931ZM111.534 34.451C111.479 32.647 112.971 31.723 114.04 31.723C114.878 31.723 115.589 32.1314 115.826 32.7157L111.534 34.451ZM106.318 38.9898H108.427V25.2399H106.318V38.9898ZM102.863 30.9599H102.792C102.318 30.4126 101.414 29.9176 100.269 29.9176C97.866 29.9176 95.6688 31.9746 95.6688 34.6118C95.6688 37.234 97.866 39.2745 100.269 39.2745C101.414 39.2745 102.318 38.7753 102.792 38.2116H102.863V38.8826C102.863 40.6715 101.882 41.6326 100.302 41.6326C99.0125 41.6326 98.2129 40.7251 97.8829 39.962L96.0482 40.7086C96.577 41.9488 97.9774 43.4751 100.302 43.4751C102.775 43.4751 104.862 42.0561 104.862 38.6035V30.2022H102.863V30.9599ZM100.45 37.432C98.9956 37.432 97.7785 36.2453 97.7785 34.6118C97.7785 32.9632 98.9956 31.7601 100.45 31.7601C101.882 31.7601 103.012 32.9632 103.012 34.6118C103.012 36.2453 101.882 37.432 100.45 37.432ZM127.955 25.2399H122.909V38.9898H125.013V33.78H127.955C130.292 33.78 132.584 32.1314 132.584 29.5092C132.584 26.8885 130.286 25.2399 127.955 25.2399ZM128.01 31.8674H125.013V27.1525H128.01C129.581 27.1525 130.478 28.4244 130.478 29.5092C130.478 30.5735 129.581 31.8674 128.01 31.8674ZM141.017 29.8915C139.497 29.8915 137.916 30.546 137.266 31.9966L139.133 32.7597C139.535 31.9966 140.274 31.7491 141.055 31.7491C142.147 31.7491 143.254 32.3885 143.271 33.5174V33.6617C142.89 33.4472 142.075 33.1296 141.072 33.1296C139.061 33.1296 137.012 34.209 137.012 36.2234C137.012 38.0659 138.659 39.2525 140.511 39.2525C141.927 39.2525 142.708 38.6296 143.199 37.905H143.271V38.9678H145.303V33.6934C145.303 31.2555 143.436 29.8915 141.017 29.8915ZM140.763 37.4265C140.075 37.4265 139.116 37.0937 139.116 36.2619C139.116 35.1976 140.312 34.7892 141.347 34.7892C142.274 34.7892 142.708 34.9886 143.271 35.2512C143.106 36.5245 141.982 37.4265 140.763 37.4265ZM152.707 30.1926L150.288 36.1532H150.216L147.716 30.1926H145.447L149.204 38.5223L147.06 43.1575H149.259L155.048 30.1926H152.707ZM133.74 38.9898H135.85V25.2399H133.74V38.9898Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_751_5008",
    x: 0.5,
    y: 0,
    width: 178,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_751_5008"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_751_5008",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_751_5008",
    x1: 12.5,
    y1: 28,
    x2: 166.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1035",
    style: {
      stopColor: "#1B1035",
      stopColor: "color(display-p3 0.1059 0.0627 0.2078)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04020A",
    style: {
      stopColor: "#04020A",
      stopColor: "color(display-p3 0.0176 0.0085 0.0392)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.0b8070205e35dcd84f6d58802f025db1.svg";
export { ForwardRef as ReactComponent };